import { motion } from "framer-motion";
import React from "react";
import { useState, useEffect } from "react";

import styled from "styled-components";
import { Github, Twitter, Linkedin } from "../components/AllSvgs";
import { DarkTheme } from "../components/Themes";

const Icons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: fixed;
  bottom: 0;
  left: 1.3rem;

  transform: translateY(1.8rem);

  z-index: 10;

  & > *:not(:last-child) {
    margin: 0.5rem 0;
  }

  @media (max-width: 320px) {
    left: 1.3rem;
  }
`;

const Line = styled(motion.span)`
  width: 2px;
  height: 8rem;
  background-color: ${(props) =>
    props.color === "dark" ? DarkTheme.text : DarkTheme.body};
`;

const SocialIcons = (props) => {

  const [iconSize, setIconSize] = useState(25);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 420) {
        setIconSize(20);
      } else {
        setIconSize(25);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Icons>

      {/* GitHub */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1 }}
      >
        <a target="_blank" rel="noreferrer" href="https://github.com/RajaretnamR">
          <Github
            width={iconSize}
            height={iconSize}
            fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      {/* Twitter / X */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.2 }}
      >
        <a target="_blank" rel="noreferrer" href="https://x.com/Rajaa_retnam">
          <Twitter
            width={iconSize}
            height={iconSize}
            fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      {/* LinkedIn */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.4 }}
      >
        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/raja-retnam/">
          <Linkedin
            width={iconSize}
            height={iconSize}
            fill={props.theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      <Line
        color={props.theme}
        initial={{ height: 0 }}
        animate={{ height: "8rem" }}
        transition={{ type: "spring", duration: 1, delay: 0.8 }}
      />
    </Icons>
  );
};

export default SocialIcons;